/* eslint-disable react/no-danger */

import React, { useState, useEffect, memo } from 'react';
import propTypes from 'prop-types';
import { DragSource, DropTarget } from 'react-dnd';
import { connect, useDispatch } from 'react-redux';
import cn from 'classnames';
import moment from '~/Providers/Moment';
import { HABIT } from '~/Config/DragTypes';
import Edit from '~/Components/Global/Assets/Svgs/Edit';
import { openModal, setModalData } from '~/Redux/Modules/Modal';
import { HABIT_CREATE_EDIT_MODAL } from '~/Config/Modals';
import { updateHabit } from '~/Redux/Modules/Habits';
import Store from '~/Redux/Store';
import { nextPriority } from './helpers';
import habitIcons from './HabitIconsLibrary';
import './HabitsColumn.scss';

const habitDrag = {
  beginDrag: ({ habit }) => {
    return {
      habit,
    };
  },
};

const habitTarget = {
  canDrop: ({ habit: { id } }, monitor) => {
    return id !== monitor.getItem().habit.id;
  },
  drop: (target, monitor) => {
    const habit = monitor.getItem().habit;
    const next = target.habit;
    const prev = target.prevHabit;
    const updatedHabit = {
      ...habit,
      priority: nextPriority(prev, next),
    };
    if (updatedHabit !== null) {
      Store.dispatch(updateHabit(updatedHabit));
    }
  },
};

const dragCollect = (connect, monitor) => ({
  connectDragPreview: connect.dragPreview(),
  connectDragSource: connect.dragSource(),
  isDragging: monitor.isDragging(),
});

const dropCollect = (connect, monitor) => ({
  connectDropTarget: connect.dropTarget(),
  isOver: monitor.isOver(),
  canDrop: monitor.canDrop(),
});

export const HabitItem = ({
  habit,
  isDragging,
  connectDropTarget,
  connectDragPreview,
  connectDragSource,
  isOver,
  canDrop,
  habits,
  start,
  trackedHabits,
  prevHabit,
}) => {
  const dispatch = useDispatch();

  return connectDropTarget(
    connectDragPreview(
      <div
        key={habit.id}
        className={cn('habit-row', 'habit', {
          'is-over': isOver && canDrop,
          'is-dragging': isDragging,
          'not-first-child': prevHabit !== null,
        })}
        onClick={() => {
          dispatch(setModalData({ habit: habit }));
          dispatch(openModal(HABIT_CREATE_EDIT_MODAL));
        }}
      >
        {connectDragSource(
          <div className="habit-row-icon">
            {React.cloneElement(habitIcons[habit.icon], { fill: habit.color })}
          </div>
        )}
        <div className="habit-title">{habit.title}</div>
        <div
          className="edit-icon"
          onClick={() => {
            dispatch(setModalData({ habit: habit }));
            dispatch(openModal(HABIT_CREATE_EDIT_MODAL));
          }}
        >
          <Edit />
        </div>
        <div
          className="habit-streak-container"
          style={{ backgroundColor: habit.recent_streak >= 2 ? habit.color : 'transparent' }}
        >
          <div className="habit-streak">{habit.recent_streak}</div>
        </div>
      </div>
    )
  );
};

HabitItem.propTypes = {
  habit: propTypes.shape({ id: propTypes.string.isRequired }).isRequired,
  isDragging: propTypes.bool,
  connectDropTarget: propTypes.func,
  connectDragPreview: propTypes.func,
  connectDragSource: propTypes.func,
  canDrop: propTypes.bool,
  habits: propTypes.array,
  start: propTypes.object,
  trackedHabits: propTypes.array,
  prevHabit: propTypes.object,
};

const mapStateToProps = ({ DateRange, Habits, HabitTrackeds }) => {
  return {
    trackedHabits: HabitTrackeds.habitTrackedCollection.habitsTracked,
    habits: Habits.habitCollection.habits,
    start: DateRange.start,
  };
};

export default memo(
  connect(mapStateToProps)(
    HabitItem
      |> DropTarget(HABIT, habitTarget, dropCollect)
      |> DragSource(HABIT, habitDrag, dragCollect)
  )
);
